export enum QuarantineStatus {
  Waiting = "File is waiting",
  Processing = "File is being processed",
  Accepted = "File accepted",
  Rejected = "File rejected",
}

export class Quarantine {
  public fileName!: string;

  public edxFileName!: string;

  public fileReference!: string;

  public source!: string;

  public uploadedBy!: string;

  public ipAddress!: string;

  public uploadedOn?: Date;

  public status!: string;

  public rejectionReason?: string;

  public lastRequested?: Date;

  constructor() {
    this.source = "User Upload";
  }

  public get statusText(): string {
    const statusString = this.status as keyof typeof QuarantineStatus;
    return QuarantineStatus[statusString];
  }

  public get getRejectionReason(): string {
    return this.rejectionReason ?? "Unknown reason";
  }

  public isInStatus(status: string | string[]) {
    const statuses = Array.isArray(status) ? status : [status];
    statuses.forEach((statusItem) => {
      const statusString = statusItem as keyof typeof QuarantineStatus;
      if (this.status === statusString) {
        return true;
      }
    });
    return false;
  }
}

export interface QuarantineUpload {
  fileName: string;
  edxFileName: string;
  fileReference: string;
  source: string;
}
